<!-- ════════════════════════════════════════════════
     VISION FOR UMMAH — HOME PAGE
     ════════════════════════════════════════════════ -->
<app-header-style-two></app-header-style-two>

<!-- ① Hero Slider -->
<app-hometwo-main-banner></app-hometwo-main-banner>

<!-- ② Stats / Fun Facts -->
<section class="section-sm" style="background: var(--cream-200);">
  <div class="container">
    <app-funfacts></app-funfacts>
  </div>
</section>

<!-- ③ About us strip -->
<app-hometwo-about></app-hometwo-about>

<!-- ④ Branches / Partners -->
<section class="partner-area" style="background: var(--cream-300); padding-block: var(--sp-16);">
  <div class="container">
    <div class="section-title text-center" style="margin-bottom: var(--sp-8);">
      <span class="sub-title">انتشارنا</span>
      <h2 style="margin-top: var(--sp-3);">مراكزنا</h2>
    </div>
    <app-partner-style-one></app-partner-style-one>
  </div>
</section>

<!-- ⑤ Latest News -->
<section class="blog-area">
  <div class="container">
    <div class="section-title text-start">
      <h2>{{"MENU.News" | translate}}</h2>
      <a routerLink="/news" class="default-btn">
        <span class="label">{{"MENU.ReadAll" | translate}}</span>
      </a>
    </div>

    <div class="row">
      <div class="col-lg-3 col-md-6" *ngFor="let item of news" style="margin-bottom: var(--sp-6);">
        <div class="vfu-card">
          <div class="vfu-card-img">
            <a [routerLink]="['/details','news', item.referenceId]">
              <img [src]="createImgPath(item.img1)" alt="{{ item.title }}">
            </a>
            <span class="vfu-card-tag" *ngIf="item.keyWord">{{ item.keyWord }}</span>
          </div>

          <div class="vfu-card-body">
            <div class="vfu-card-meta" *ngIf="item.shortText">
              <i class='bx bx-info-circle'></i>
              <span>{{ item.shortText }}</span>
            </div>

            <div class="vfu-card-title">
              <a [routerLink]="['/details','news', item.referenceId]">{{ item.title }}</a>
            </div>

            <a [routerLink]="['/details','news', item.referenceId]" class="vfu-read-more">
              {{ "MENU.ReadMore" | translate }}
              <i class='bx bx-left-arrow-alt'></i>
            </a>
          </div>
        </div>
      </div>
    </div>

  </div>
</section>